<template>
<div class="chapter">
<div class="inner_page">
      ﻿ <title>Believing Jesus: Are You Willing to Risk Everything?: A Journey Through the Book of Acts</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ct" id="pz11-1"><i>Contents</i><a id="AEE"></a></p><a id="AEE">
</a><p class="cct" id="pA98"><a id="AEE"></a><a href="#/chapter02#toc2" id="con2"><b>one:</b> THE COST OF DISCIPLESHIP</a></p>
<p class="cct" id="pAno"><a href="#/chapter03#toc3" id="con3"><b>two:</b> EARTH, WIND, AND CELESTIAL FIRE</a> </p>
<p class="cct" id="pAqg"><span href="#/chapter04#toc4" id="con4" title="Link target outside of Sample"><b>three:</b> CHECKERED PASTS CAN MAKE INCREDIBLE PREACHERS</span> </p>
<p class="cct" id="pAKB"><span href="#/chapter05#toc5" id="con5" title="Link target outside of Sample"><b>four:</b> WHAT’S MINE IS YOURS</span> </p>
<p class="cct" id="pAmS"><span href="#/chapter06#toc6" id="con6" title="Link target outside of Sample"><b>five:</b> LOVING MORE PEOPLE, MORE</span> </p>
<p class="cct" id="Ada"><span href="#/chapter07#toc7" id="con7" title="Link target outside of Sample"><b>six:</b> SINNERS WHO WOULD BE SAINTS</span> </p>
<p class="cct" id="AXG"><span href="#/chapter08#toc8" id="con8" title="Link target outside of Sample"><b>seven:</b> A COMPASSIONATE COMPULSION</span> </p>
<p class="cct" id="ArWR"><span href="#/chapter09#toc9" id="con9" title="Link target outside of Sample"><b>eight:</b> THE NEED TO BE REGOSPELED</span> </p>
<p class="cct" id="AgY"><span href="#/chapter10#toc10" id="con10" title="Link target outside of Sample"><b>nine:</b> BEARING THE CHAIN BECAUSE</span> </p>
<p class="cct" id="A1u"><span href="#/chapter11#toc11" id="con11" title="Link target outside of Sample"><b>ten:</b> KICKING SAFE, COMFORTABLE CHRISTIANITY TO THE CURB</span></p>
<p class="cct1" id="pz11-3" style="text-indent: 0"><span href="#/chapter12#toc12" id="con12" title="Link target outside of Sample">NOTES</span></p>
<p class="cct1" id="pz11-4" style="text-indent: 0"><span href="#/chapter13#toc13" id="con13" title="Link target outside of Sample">ABOUT THE AUTHOR</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?010cf1aa